/**
 * Per-page share copy. A page without an entry here simply hides the Share
 * button rather than offering an empty/broken share.
 */
export type ShareConfig = { title: string; text: string };

const SITE = "The Quantum Minds";

const CONFIG: Record<string, ShareConfig> = {
  "/": {
    title: SITE,
    text: `I'm using ${SITE} to track my entire exam preparation in one place. Check it out:`,
  },
  "/revisions": {
    title: `${SITE} · Revision Planner`,
    text: `I'm using the ${SITE} Revision Planner to manage my preparation. Check it out:`,
  },
  "/questions": {
    title: `${SITE} · Question Tracker`,
    text: `I'm tracking my daily practice questions with the ${SITE} Question Tracker. Check it out:`,
  },
  "/tests": {
    title: `${SITE} · Test Tracker`,
    text: `I'm tracking my mock test scores and analysis on the ${SITE} Test Tracker. Check it out:`,
  },
  "/toolkit": {
    title: `${SITE} · Study Toolkit`,
    text: `The ${SITE} Toolkit has calculators, formula sheets and reference tools for PCMB. Check it out:`,
  },
  "/simulations": {
    title: `${SITE} · Simulations`,
    text: `These interactive physics & chemistry simulations on ${SITE} make concepts click. Check them out:`,
  },
  "/labs": {
    title: `${SITE} · Sim Labs`,
    text: `I'm doing virtual practicals in the ${SITE} Sim Labs. Check it out:`,
  },
  "/mindmaps": {
    title: `${SITE} · Mindmaps`,
    text: `These chapter-wise mindmaps on ${SITE} make revision much faster. Check them out:`,
  },
  "/pyq-predictor": {
    title: `${SITE} · PYQ Predictor`,
    text: `The ${SITE} PYQ Predictor shows which chapters actually matter in the exam. Check it out:`,
  },
  "/prerequisites": {
    title: `${SITE} · Chapter Prerequisites`,
    text: `${SITE} shows exactly what to study before each chapter. Check it out:`,
  },
  "/college-predictor": {
    title: `${SITE} · College Predictor`,
    text: `I used the ${SITE} College Predictor to see which colleges my rank can get. Check it out:`,
  },
  "/tracker-360": {
    title: `${SITE} · Tracker 360 Pro`,
    text: `Tracker 360 Pro on ${SITE} built my full backlog-to-exam study schedule. Check it out:`,
  },
  "/what-if": {
    title: `${SITE} · What If? Lab`,
    text: `The What If? Lab on ${SITE} is a fun way to explore science scenarios. Check it out:`,
  },
};

/** Returns share copy for a pathname, or null when the page isn't shareable. */
export function getShareConfig(pathname: string): ShareConfig | null {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (CONFIG[path]) return CONFIG[path];
  // Nested routes inherit their section's copy (e.g. /toolkit/c/physics).
  const section = `/${path.split("/")[1] ?? ""}`;
  return CONFIG[section] ?? null;
}
